import React from 'react';
import { GiftIcon } from 'lucide-react';
import { Section } from './Section';
import { SectionCta } from './SectionCta';
import { bonuses } from '../data/content';
export function Bonuses() {
  return <Section eyebrow="🎁 Included free" title="Plus: 5 clinical tools included free" intro="You’ll also receive 5 practical tools designed to help you apply the system directly to your aligner workflow." data-id="element-60" data-mp="avv308cxxatj">
      <div className="grid gap-4 sm:grid-cols-2" data-id="element-61" data-mp="1stwi6k5xhpc">
        {bonuses.map((bonus, i) => <article key={bonus.tag} className={`flex flex-col rounded-3xl border border-lime/20 bg-ink-800 p-5 ${i === bonuses.length - 1 ? 'sm:col-span-2' : ''}`} data-id="element-62" data-mp="5wrwskl84yjz" data-mpi={i}>
            <img src={bonus.image} alt={`${bonus.title} digital mockup`} className="mx-auto mb-4 w-full max-w-[300px] drop-shadow-[0_18px_40px_rgba(198,230,43,0.14)]" loading="lazy" data-id="element-63" data-mp="3t2sm0nfrgeoj" />
            <span className="flex w-fit items-center gap-1.5 rounded-full bg-lime/15 px-3 py-1 text-[11px] font-black uppercase tracking-wider text-lime" data-id="element-64" data-mp="3idmz7yg0j9gl">
              <GiftIcon className="h-3.5 w-3.5" data-id="element-65" data-mp="3ddis2z0zvr31" /> {bonus.tag}
            </span>
            <h3 className="mt-3 font-display text-base leading-tight text-white sm:text-lg" data-id="element-66" data-mp="3r5ynperkgmtx">
              {bonus.title}
            </h3>
            <p className="mt-2 text-sm font-semibold text-white/85" data-id="element-67" data-mp="2zfanq61mpnhu">{bonus.lead}</p>
            <p className="mt-2 flex-1 text-sm leading-relaxed text-white/60" data-id="element-68" data-mp="2zhf0ldhi9wu9">{bonus.body}</p>
            <p className="mt-4 text-xs font-bold uppercase tracking-wide text-lime" data-id="element-69" data-mp="2uik63ea6ejub">
              Value: {bonus.value} — Included free
            </p>
          </article>)}
      </div>

      <SectionCta headline="All 5 tools are included today at no extra cost." data-id="element-70" data-mp="33ja14frm466z" />
    </Section>;
}